import { useLanguage, t } from "../../../i18n";
import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/layout/Header/Header";
import Logo from "../../../components/common/Logo/Logo";
import MobileOffcanvasNav from "../../../components/layout/MobileOffcanvasNav/MobileOffcanvasNav";
import Footer from "../../../components/layout/Footer/Footer";
import ROUTES from "../../../config/routes";
import "./NotFound.css";
export default function NotFound() {
  useLanguage();
  const [showMobileNav, setShowMobileNav] = useState(false);
  const navigate = useNavigate();
  return <div className="bb-public-page bb-notfound-page">
            <Header onMenuClick={() => setShowMobileNav(true)} />

            <MobileOffcanvasNav show={showMobileNav} onHide={() => setShowMobileNav(false)} />


            <main className="bb-notfound-page__main">
                <Container>
                    <div className="bb-notfound-page__content">
                        <div className="bb-auth-logo mb-4 text-start">
                            <Logo />
                        </div>

                        <div className="bb-notfound-page__code">404</div>

                        <h1 className="bb-notfound-page__title">{t("The page you are looking for could not be found")}

            </h1>

                        <p className="bb-notfound-page__subtitle">{t("The link may be broken, the page may have been moved, or the URL may be incorrect. You can return to the homepage, explore room listings, or continue to login.")}



            </p>

                        <div className="bb-notfound-page__actions">
                            <Button className="bb-notfound-page__primary-btn" onClick={() => navigate(ROUTES.ROOT)}>{t("Back to Home")}


              </Button>

                            <Button variant="outline-primary" className="bb-brand-btn-outline" onClick={() => navigate(ROUTES.LISTINGS)}>{t("Explore Listings")}


              </Button>

                            <Button variant="outline-secondary" className="bb-notfound-page__secondary-btn" onClick={() => navigate(ROUTES.LOGIN)}>{t("Login")}


              </Button>
                        </div>
                    </div>
                </Container>
            </main>

            <Footer />
        </div>;
}
